import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserId } from 'react-project/Util/AuthCookie';
import RequestService from 'react-project/Helpers/RequestService';
import { selectUserData } from 'react-project/redux/user/selectors';
import { setUserHash } from 'react-project/redux/user/actions';

export const IntercomScript = () => {
  const userId = getUserId();
  const [userSettings, setUserSettings] = useState(null);
  const userData = useSelector(selectUserData);

  useEffect(() => {
    if (!userId) return;

    const fetchUserData = async () => {
      try {
        const requestService = new RequestService();

        const hashResponse = await requestService.getUserHash(userData.id);
        let userHash = null;

        if (hashResponse && hashResponse.success) {
          setUserHash(hashResponse.data.hash);
          userHash = hashResponse.data.hash;
        }

        const intercomSettings = {
          api_base: 'https://api-iam.intercom.io',
          app_id: 'ljngx1r9',
          user_id: userData.id,
          name: userData.first_name,
          email: userData.email,
          created_at: Math.floor(new Date(userData.created_at).getTime() / 1000),
          user_hash: userHash,
        };

        setUserSettings(intercomSettings);
      } catch (error) {
        console.error('Failed to fetch Intercom settings:', error);
      }
    };

    fetchUserData();
  }, [userId]);

  useEffect(() => {
    if (!userSettings) return;
    if (window.intercomSettings) return; // make sure it only runs once

    window.intercomSettings = userSettings;

    (function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/ljngx1r9';
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();
  }, [userSettings]);

  return null;
};
